import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initAnalytics } from "./analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// After render, not before: initAnalytics() catches its own failures, but a
// throw here would still blank the app if that guard ever regressed. Nothing
// captures before init anyway — every call site no-ops until `ready`.
initAnalytics();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
